module.exports = __webpack_public_path__ + "static/img/accountmanagement.e8f5f75e.png";